// AppLayout.js
import React from 'react';
import { Outlet } from 'react-router-dom';
//import Header from './Header';
//import Footer from './Footer';

const AppLayout = () => {
    return (
        <div style={{ paddingtop: '10px' }}>
            <Outlet />
        </div>
    );
};

export default AppLayout;